export default function formatDateTime(dateString: string) {
  if (!dateString) return null;
  const date = new Date(dateString);
  return {
      date: date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
      }),
      time: date.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit'
      })
  };
};